import axios from "axios";
import authHeader from "../Auth/authHeader";
import { ApiLink } from "../APILink/ApiLink";
import { errorAlert } from "../Components/Alerts";

export const fetchActiveCompanyUnits = async () => {
  const headers = authHeader();
  try {
    const response = await axios.get(
      ApiLink.API_URL + "CompanyUnits/getActiveCompanyUnits",
      {
        headers,
      },
    );
    const companyUnits = response.data;
    return companyUnits;
  } catch (error) {
    errorAlert("Gabim në kërkesë:", error);

    if (error.response?.data?.errorMessage) {
      errorAlert(`Gabim në marrjen e të dhënave`);
    } else if (error.message) {
      errorAlert(`Gabim`);
    } else {
      errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
    }

    return null; // Kthe null në rast gabimi që mos prishet përdorimi në skedarë tjerë
  }
};

//Ketu merret lista e company units ne baze te company id qe e dergojm si parameter
export const getCompanyUnits = async (companyID) => {
  const headers = authHeader();
  try {
    const response = await axios.get(
      ApiLink.API_URL + "CompanyUnits/getUnitByID",
      { headers, params: { id: companyID } },
    );

    return response.data; // Kthen vetëm të dhënat (listën)
  } catch (error) {
    // Trajtimi i gabimeve mbetet i centralizuar këtu
    const errorMessage =
      error.response?.data?.errorMessage || error.message || "Gabim i panjohur";
    errorAlert(`Gabim në marrjen e njësive: ${errorMessage}`);
    throw error; // E hedhim gabimin që komponenti ta dijë që dështoi
  }
};
